import GameLanscape from "./Game.landscape";
export default GameLanscape;
